import { z } from 'zod';

// The DLN number lives at asset_state.body.header.id in both the search assets
// and the single-DLN (by-id) response; everything else is stripped.
const zodAssetStateWithHeaderIdSchema = z
  .object({
    body: z
      .object({ header: z.object({ id: z.string() }).partial().optional() })
      .partial()
      .optional(),
  })
  .partial()
  .optional();

// Only the two fields the picker reads are validated; the search response carries
// many more that Zod strips. The asset document id comes back as `id` (the
// top-level `asset_id` is null), so the run endpoint's asset id is read from here.
export const zodDeliveryNoteSearchAssetSchema = z.object({
  assetState: zodAssetStateWithHeaderIdSchema,
  // Existing, stable search endpoint — validate only the shape, not the id
  // format, so a valid response can never wipe the picker results.
  id: z.string(),
});

// GET asset/delivery_note/:id returns the full asset main document; the picker
// only needs the DLN number for the option label (the asset id is already known
// from the lookup itself).
export const zodDeliveryNoteByIdResponseSchema = z.object({
  assetState: zodAssetStateWithHeaderIdSchema,
});

export const zodDeliveryNoteSearchResponseSchema = z.object({
  assets: z.array(zodDeliveryNoteSearchAssetSchema).optional(),
});
